import Header from "@/components/Header";
import Hero from "@/components/Hero";
import Services from "@/components/Services";
import About from "@/components/About";
import CTA from "@/components/CTA";
import Footer from "@/components/Footer";
import MobileCallButton from "@/components/MobileCallButton";
import CookieConsent from "@/components/CookieConsent";

const Index = () => {
  return (
    <div className="min-h-screen">
      <Header />
      <main id="main-content">
        <Hero />
        <Services />
        <About />
        <CTA />
      </main>
      <Footer />
      <MobileCallButton />
      <CookieConsent />
    </div>
  );
};

export default Index;
